import React, { useEffect, useState } from 'react';
import Card from '../../components/ui/Card';
import Btn from '../../components/ui/Btn';
import Badge from '../../components/ui/Badge';
import Modal from '../../components/ui/Modal';
import { Input, Select } from '../../components/ui/Input';
import { usuariosApi, tenantsApi, empresasApi } from '../../api/admin';
import { COLORS } from '../../theme';

const PERFIS_CLIENTE = [
  { value: 'gestor', label: 'Gestor (acesso a tudo)' },
  { value: 'vendedor', label: 'Vendedor' },
  { value: 'comprador', label: 'Comprador' },
  { value: 'estoquista', label: 'Estoquista' }
];
const PERFIS_CORENADMIN = [{ value: 'admin', label: 'Admin (super-admin Coren)' }];

const FORM_VAZIO = { nome: '', email: '', senha: '', perfil: 'admin', tenant_id: '' };

export default function UsuariosList() {
  const [usuarios, setUsuarios] = useState([]);
  const [clientes, setClientes] = useState([]);
  const [empresasDoCliente, setEmpresasDoCliente] = useState([]);
  const [empresasSelecionadas, setEmpresasSelecionadas] = useState([]);
  const [modalAberto, setModalAberto] = useState(false);
  const [usuarioEditando, setUsuarioEditando] = useState(null);
  const [form, setForm] = useState(FORM_VAZIO);
  const [salvando, setSalvando] = useState(false);
  const [erro, setErro] = useState('');

  const carregar = () => usuariosApi.listar().then(setUsuarios).catch(() => {});
  useEffect(() => {
    carregar();
    tenantsApi.listar().then(setClientes).catch(() => {});
  }, []);

  useEffect(() => {
    if (!form.tenant_id) { setEmpresasDoCliente([]); if (!usuarioEditando) setEmpresasSelecionadas([]); return; }
    empresasApi.listar(form.tenant_id).then(lista => {
      setEmpresasDoCliente(lista);
      if (!usuarioEditando) setEmpresasSelecionadas(lista.filter(e => e.padrao).map(e => e.id));
    }).catch(() => {});
  }, [form.tenant_id]); // eslint-disable-line

  const onChange = (campo, valor) => setForm(f => ({ ...f, [campo]: valor }));

  const onChangeCliente = (tenantId) => {
    setForm(f => ({
      ...f,
      tenant_id: tenantId,
      perfil: tenantId ? (f.perfil === 'admin' ? 'gestor' : f.perfil) : 'admin'
    }));
  };

  const alternarEmpresa = (id) => {
    setEmpresasSelecionadas(sel => sel.includes(id) ? sel.filter(x => x !== id) : [...sel, id]);
  };

  const abrirNovo = () => {
    setUsuarioEditando(null);
    setForm(FORM_VAZIO);
    setEmpresasSelecionadas([]);
    setErro('');
    setModalAberto(true);
  };

  const abrirEdicao = async (usuario) => {
    setUsuarioEditando(usuario);
    setForm({ nome: usuario.nome, email: usuario.email, senha: '', perfil: usuario.perfil, tenant_id: usuario.tenant_id || '' });
    setErro('');
    setModalAberto(true);
    try {
      const empresasAtuais = await usuariosApi.obterEmpresas(usuario.id);
      setEmpresasSelecionadas(empresasAtuais);
    } catch (e) {
      setEmpresasSelecionadas([]);
    }
  };

  const salvar = async (e) => {
    e.preventDefault();
    setSalvando(true);
    setErro('');
    try {
      const dados = { ...form, tenant_id: form.tenant_id || null, empresas: empresasSelecionadas };
      if (usuarioEditando) {
        if (!dados.senha) delete dados.senha;
        await usuariosApi.atualizar(usuarioEditando.id, dados);
      } else {
        await usuariosApi.criar(dados);
      }
      setModalAberto(false);
      carregar();
    } catch (err) {
      setErro(err.message);
    } finally {
      setSalvando(false);
    }
  };

  const alternarAtivo = async (usuario) => {
    const acao = usuario.ativo ? 'desativar' : 'reativar';
    if (!window.confirm(`Tem certeza que quer ${acao} o usuário "${usuario.nome}"?`)) return;
    await usuariosApi.atualizar(usuario.id, { ativo: usuario.ativo ? 0 : 1 });
    carregar();
  };

  const opcoesClientes = [{ value: '', label: '(nenhum — super-admin Coren)' }, ...clientes.map(c => ({ value: c.id, label: c.nome }))];

  return (
    <div>
      <Card style={{ padding: 0, overflow: 'hidden' }}>
        <div style={{ padding: 14, borderBottom: `1px solid ${COLORS.border}`, display: 'flex', justifyContent: 'flex-end' }}>
          <Btn onClick={abrirNovo}>+ Novo Usuário</Btn>
        </div>
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
          <thead>
            <tr style={{ textAlign: 'left', background: COLORS.bg }}>
              <th style={{ padding: 10 }}>Nome</th>
              <th style={{ padding: 10 }}>Email</th>
              <th style={{ padding: 10 }}>Cliente</th>
              <th style={{ padding: 10 }}>Perfil</th>
              <th style={{ padding: 10 }}>Status</th>
              <th style={{ padding: 10 }}></th>
            </tr>
          </thead>
          <tbody>
            {usuarios.map(u => (
              <tr key={u.id} style={{ borderTop: `1px solid ${COLORS.border}` }}>
                <td style={{ padding: 10 }}>{u.nome}</td>
                <td style={{ padding: 10 }}>{u.email}</td>
                <td style={{ padding: 10 }}>{u.tenant_nome || <Badge tom="info">Coren (super-admin)</Badge>}</td>
                <td style={{ padding: 10 }}>{u.perfil}</td>
                <td style={{ padding: 10 }}>{u.ativo ? <Badge tom="sucesso">Ativo</Badge> : <Badge tom="perigo">Inativo</Badge>}</td>
                <td style={{ padding: 10, display: 'flex', gap: 8 }}>
                  <Btn tamanho="sm" variante="ghost" onClick={() => abrirEdicao(u)}>Editar</Btn>
                  <Btn tamanho="sm" variante={u.ativo ? 'danger' : 'secondary'} onClick={() => alternarAtivo(u)}>
                    {u.ativo ? 'Desativar' : 'Reativar'}
                  </Btn>
                </td>
              </tr>
            ))}
            {usuarios.length === 0 && (
              <tr><td colSpan={6} style={{ padding: 20, textAlign: 'center', color: COLORS.textMid }}>Nenhum usuário cadastrado ainda.</td></tr>
            )}
          </tbody>
        </table>
      </Card>

      {modalAberto && (
        <Modal
          titulo={usuarioEditando ? `Editar "${usuarioEditando.nome}"` : 'Novo Usuário'}
          onFechar={() => setModalAberto(false)}
          largura={480}
          rodape={
            <>
              <Btn variante="ghost" onClick={() => setModalAberto(false)}>Cancelar</Btn>
              <Btn onClick={salvar} disabled={salvando}>{salvando ? 'Salvando...' : 'Salvar'}</Btn>
            </>
          }
        >
          <form onSubmit={salvar} style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
            <Input label="Nome" value={form.nome} onChange={e => onChange('nome', e.target.value)} required />
            <Input label="Email" type="email" value={form.email} onChange={e => onChange('email', e.target.value)} required />
            <Input label={usuarioEditando ? 'Nova Senha (deixe em branco para manter)' : 'Senha'} type="password"
              value={form.senha} onChange={e => onChange('senha', e.target.value)} required={!usuarioEditando} />
            <Select label="Cliente" options={opcoesClientes} value={form.tenant_id} onChange={e => onChangeCliente(e.target.value)} />
            <Select
              label="Perfil"
              options={form.tenant_id ? PERFIS_CLIENTE : PERFIS_CORENADMIN}
              value={form.perfil}
              onChange={e => onChange('perfil', e.target.value)}
              disabled={!form.tenant_id}
            />

            {form.tenant_id && empresasDoCliente.length > 0 && (
              <div>
                <div style={{ fontSize: 12, fontWeight: 600, color: COLORS.textMid, marginBottom: 6 }}>
                  Pode vender/operar em quais empresas (CNPJs)?
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
                  {empresasDoCliente.map(emp => (
                    <label key={emp.id} style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 13 }}>
                      <input type="checkbox" checked={empresasSelecionadas.includes(emp.id)} onChange={() => alternarEmpresa(emp.id)} />
                      {emp.nome} {emp.padrao ? <Badge tom="info">Padrão</Badge> : null}
                    </label>
                  ))}
                </div>
                <p style={{ fontSize: 11, color: COLORS.textLight, margin: '6px 0 0' }}>
                  Se marcar mais de uma, o usuário verá um seletor de empresa no painel dele. Nenhuma marcada = gestor vê todas, os demais perfis só a padrão.
                </p>
              </div>
            )}

            {erro && <p style={{ color: COLORS.danger, fontSize: 13, margin: 0 }}>{erro}</p>}
          </form>
        </Modal>
      )}
    </div>
  );
}
